import api from "../../../api/axios";

const fetchAllowUpdate = async (serverUuid) => {
  try {
    const response = await api.get(`/api/servers/${serverUuid}/allowUpdate`);
    return response.data.allowUpdate;
  } catch (error) {
    console.error("fetchAllowUpdate", error);
    return undefined;
  }
};

const updateAllowUpdate = async (serverUuid, allowUpdate) => {
  try {
    const response = await api.put(`/api/servers/${serverUuid}/allowUpdate`, {
      allowUpdate,
    });
    return response.status === 200;
  } catch (error) {
    console.error("updateAllowUpdate", error);
    return false;
  }
};

const fetchPollingInterval = async (serverUuid) => {
  try {
    const response = await api.get(
      `/api/servers/${serverUuid}/pollingInterval`
    );
    return response.data.pollingInterval;
  } catch (error) {
    console.error("fetchPollingInterval", error);
    return undefined;
  }
};

const updatePollingInterval = async (serverUuid, pollingInterval) => {
  try {
    const response = await api.put(
      `/api/servers/${serverUuid}/pollingInterval`,
      {
        pollingInterval,
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("updatePollingInterval", error);
    return false;
  }
};

const fetchLicenseValidDate = async (serverUuid) => {
  try {
    const response = await api.get(
      `/api/servers/${serverUuid}/licensevaliddate`
    );
    return response.data.licenseValidDate;
  } catch (error) {
    console.error("fetchLicenseValidDate", error);
    return undefined;
  }
};

const updateLicenseValidDate = async (serverUuid, licenseValidDate) => {
  try {
    const response = await api.put(
      `/api/servers/${serverUuid}/licensevaliddate`,
      {
        licenseValidDate,
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("updateLicenseValidDate", error);
    return false;
  }
};

const updateServerSettings = async (serverUuid, settings) => {
  try {
    const response = await api.put(`/api/servers/${serverUuid}`, settings);
    return response.status === 200;
  } catch (error) {
    console.error("updateServerSettings", error);
    return false;
  }
};

const fetchServerSettings = async (serverUuid) => {
  try {
    const response = await api.get(`/api/servers/${serverUuid}`);

    return response.data;
  } catch (error) {
    console.error("fetchServerSettings", error);
    return false;
  }
};

export default {
  fetchAllowUpdate,
  updateAllowUpdate,
  fetchPollingInterval,
  updatePollingInterval,
  fetchLicenseValidDate,
  updateLicenseValidDate,
  updateServerSettings,
  fetchServerSettings,
};
